import {useCallOnce$} from "@web-libs/util/hooks/use-call-once";
import {useReactiveHandler} from "@web-libs/util/hooks/use-reactive-handler";
import {ChatRepository} from "@web-libs/features/chat/domain/chat.repository";
import {DependencyList} from "react";
import {ChatMessage} from "@web-libs/features/chat/domain/types/chat-message.types";

type OnMessagePayload = { message: ChatMessage, chatroomId: string };
export const useChatMessageHandler = (chatRepository: ChatRepository, handler: (data:OnMessagePayload) => void, deps: DependencyList) => {
    const registerOnce = useCallOnce$();

    const _registerMessageHandler = () => {
        registerOnce(() => {
            chatRepository.onMessage((message, chatroomId) => {
                _messageHandler({message, chatroomId});
            })
        })
    }

    const _messageHandler = useReactiveHandler<OnMessagePayload>(({message, chatroomId}) => {
        handler({message, chatroomId});
    }, [deps])

    return {
        registerMessageHandleOnce: _registerMessageHandler
    }
}
